import PropTypes from "prop-types"
import React, { useState } from "react"

import {
  Row,
  Col,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"

import { withRouter, Link } from "react-router-dom"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

// actions
import { loginUser, socialLogin } from "../../store/actions"
// import images
import CarouselPage from "pages/AuthenticationInner/CarouselPage"
import logo from "../../assets/images/mazyaLogo1.png"
import logoWhite from "../../assets/images/mazayaaLogo.png"
import { withTranslation } from "react-i18next"

// //Import config
// import { facebook, google } from "../../config";

const Login = props => {
  //meta title
  document.title = "Mazaya"

  const dispatch = useDispatch()

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: values => {
      dispatch(loginUser(values, props.history))
    },
  })

  const { error } = useSelector(state => ({
    error: state.Login.error,
  }))

  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown)
  }
  const [passwordShown, setPasswordShown] = useState(false)
  const signIn = (res, type) => {
    if (type === "google" && res) {
      const postData = {
        name: res.profileObj.name,
        email: res.profileObj.email,
        token: res.tokenObj.access_token,
        idToken: res.tokenId,
      }
      dispatch(socialLogin(postData, props.history, type))
    } else if (type === "facebook" && res) {
      const postData = {
        name: res.name,
        email: res.email,
        token: res.accessToken,
        idToken: res.tokenId,
      }
      dispatch(socialLogin(postData, props.history, type))
    }
  }

  //handleGoogleLoginResponse
  // const googleResponse = response => {
  //   signIn(response, "google");
  // };

  // //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  //handleFacebookLoginResponse
  // const facebookResponse = response => {
  //   signIn(response, "facebook");
  // };

  // function myFunction() {
  //   var x = document.getElementById("myInput");
  //   if (x.type === "password") {
  //     x.type = "text";
  //   } else {
  //     x.type = "password";
  //   }
  // }

  return (
    <React.Fragment>
      <div>
        <Container fluid className="p-0">
          <Row className="g-0">
            <CarouselPage />

            <Col xl={3}>
              <div className="auth-full-page-content p-md-5 p-4 bg-white">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-0 mb-md-5 d-flex flex-column justify-content-center align-items-center">
                      <Link to="/dashboard" className="d-block auth-logo">
                        <img
                          src={logo}
                          alt=""
                          height="100"
                          className="auth-logo-dark"
                        />
                        <img
                          src={logoWhite}
                          alt=""
                          height="80"
                          className="auth-logo-light"
                        />
                      </Link>
                    </div>

                    <div className="my-auto">
                      <div className="align-items-center">
                        <h5 className="text-primary">
                          {props.t("Welcome Back")} !
                        </h5>
                        <p className="text-muted">
                          {props.t("Sign in to continue")}
                        </p>
                      </div>

                      <div className="mt-4">
                        <Form
                          className="form-horizontal"
                          onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                          }}
                        >
                          {error == "404" && (
                            <Alert color="danger">
                              {props.t("Sorry, We couldn't find your account!")}
                            </Alert>
                          )}
                          {error == "401" && (
                            <Alert color="danger">
                              {props.t("Wrong credentials")}
                            </Alert>
                          )}
                          <div className="mb-3">
                            <Label className="form-label">
                              {props.t("Email")}
                            </Label>
                            <Input
                              name="email"
                              className="form-control"
                              placeholder={props.t("Enter email")}
                              type="email"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.email || ""}
                              invalid={
                                validation.touched.email &&
                                validation.errors.email
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.email &&
                            validation.errors.email ? (
                              <FormFeedback type="invalid">
                                {validation.errors.email}
                              </FormFeedback>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label className="form-label">
                              {props.t("Password")}
                            </Label>
                            <Input
                              name="password"
                              value={validation.values.password || ""}
                              type="password"
                              placeholder={props.t("Enter password")}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.password &&
                                validation.errors.password
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.password &&
                            validation.errors.password ? (
                              <FormFeedback type="invalid">
                                {validation.errors.password}
                              </FormFeedback>
                            ) : null}
                          </div>

                          <div className="form-check">
                            <Input
                              type="checkbox"
                              className="form-check-input"
                              id="auth-remember-check"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="auth-remember-check"
                            >
                              {props.t("Remember me")}
                            </label>
                          </div>

                          <div className="mt-3 d-grid">
                            <button
                              className="btn btn-primary btn-block "
                              type="submit"
                            >
                              {props.t("Log in")}
                            </button>
                          </div>
                        </Form>

                        {/* <div className="mt-2">
                          <p>
                            <Link
                              to="forgot-password"
                              className="fw-medium text-info"
                            >
                              {" "}
                              Forgot password ?
                            </Link>{" "}
                          </p>
                        </div> */}
                      </div>
                    </div>

                    <div className="mt-4 mt-md-5 text-center">
                      <p className="mb-0">
                        © {new Date().getFullYear()} Mazaya. Crafted with{" "}
                        <i className="mdi mdi-heart text-danger"></i> by
                        Acclerant
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(Login))

Login.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
}
